import { useEffect, useState } from "react";
import axios from "axios";

export default function User_finances() {

  const [sites, setSites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");

    axios.get(
      `/api/user/finances`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then(res => setSites(res.data))
    .finally(() => setLoading(false));

  }, []);

  if (loading) return <p className="text-white">Loading...</p>;

  if (!sites.length)
    return <p className="text-white">Nemate aktivnih računa.</p>;

//  const today = new Date();
 
return (
  <div className="container mt-5">

    <div
      className="p-5 rounded-4"
      style={{
        background: "rgba(255,255,255,0.03)",
        backdropFilter: "blur(20px)",
        border: "1px solid rgba(255,255,255,0.08)",
        color: "#fff"
      }}
    >

      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-semibold mb-0">Finansije / Računi</h2>

        <span
          className="px-3 py-1 rounded-pill"
          style={{
            background: "linear-gradient(135deg,#16a34a,#15803d)",
            fontSize: "13px",
            fontWeight: "500"
          }}
        >
          {sites.reduce((sum, s) => sum + Number(s.odrzavanje), 0)} € mesečno
        </span>
      </div>

      <div className="table-responsive">
        <table
          className="w-100"
          style={{
            borderCollapse: "separate",
            borderSpacing: "0 12px"
          }}
        >
          <thead>
            <tr style={{ color: "rgba(255,255,255,0.6)", fontSize: "14px" }}>
              <th>Naziv</th>
              <th>HTTP</th>
              <th>Ref broj</th>
              <th>Mesečno</th>
              <th>Rok pretplate</th>
            </tr>
          </thead>

          <tbody>
            {sites.map((s, index) => {
              const dueDate = new Date(s.rok_pretplate);
              const isExpired = dueDate < new Date();

                return (
                  <tr
                    key={index}
                    style={{
                      background: "rgba(255,255,255,0.04)",
                      transition: "all 0.3s ease"
                    }}
                    onMouseEnter={e => {
                      e.currentTarget.style.background = "rgba(255,255,255,0.07)";
                      e.currentTarget.style.transform = "scale(1.01)";
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.background = "rgba(255,255,255,0.04)";
                      e.currentTarget.style.transform = "scale(1)";
                    }}
                  >
                    <td className="p-3 fw-medium">{s.naziv}</td>

                    <td className="p-3">
                      <a
                        href={s.httpadresa}
                        target="_blank"
                        rel="noreferrer"
                        style={{
                          color: "#60a5fa",
                          textDecoration: "none"
                        }}
                      >
                        {s.httpadresa}
                      </a>
                    </td>

                    <td className="p-3">{s.ref_num}</td>

                    <td className="p-3 fw-semibold">
                      {s.odrzavanje} €
                    </td>

                    <td className="p-3">
                      <span
                        className="px-3 py-1 rounded-pill"
                        style={{
                          fontSize: "12px",
                          fontWeight: "500",
                          background: isExpired
                            ? "linear-gradient(135deg,#ef4444,#b91c1c)"
                            : "linear-gradient(135deg,#22c55e,#15803d)",
                          color: "#fff"
                        }}
                      >
                        {s.rok_pretplate}
                        {isExpired && " • ISTEKAO ROK"}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}